import { render, staticRenderFns } from "./UnderAnalysisCandidatures.vue?vue&type=template&id=da70c796&"
import script from "./UnderAnalysisCandidatures.vue?vue&type=script&lang=js&"
export * from "./UnderAnalysisCandidatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports